import { Box, Stack, Typography, TextField, IconButton } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import DeleteIcon from '@mui/icons-material/Delete';
import { AddPhoto } from '../elements/AddPhoto';

type Props = {
  index: number;
  remove: (index: number) => void;
};

export const CustomAttributeItem = ({ index, remove }: Props) => {
  const { control } = useFormContext();

  return (
    <Box
      sx={{
        width: '100%',
        border: '1px solid #E0E0E0',
        borderRadius: 2,
        p: 2,
        mb: 3,
        position: 'relative'
      }}>
      {/* DELETE BUTTON */}
      <IconButton onClick={() => remove(index)} sx={{ position: 'absolute', top: 8, right: 8 }}>
        <DeleteIcon />
      </IconButton>

      <Typography fontWeight={600} mb={2}>
        Custom Attribute {index + 1}:
      </Typography>

      <Stack gap={2}>
        {/* CUSTOM LABEL */}
        <Typography fontSize={14}>Custom {index + 1}</Typography>
        <Controller
          name={`locationDetail.customAttributes.${index}.content`}
          control={control}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              fullWidth
              label="Enter custom field"
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              sx={{
                background: 'white',
                borderRadius: 2
              }}
            />
          )}
        />

        {/* DESCRIPTION */}
        <Typography fontSize={14}>Description</Typography>
        <Controller
          name={`locationDetail.customAttributes.${index}.desc`}
          control={control}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              fullWidth
              multiline
              minRows={3}
              label="Enter Description"
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              sx={{
                background: 'white',
                borderRadius: 2
              }}
            />
          )}
        />

        {/* PHOTO UPLOAD */}
        <Controller
          name={`locationDetail.customAttributes.${index}.photo`}
          control={control}
          render={({ field, fieldState }) => (
            <AddPhoto
              errorText={fieldState.error?.message}
              label="Custom Attribute Photo"
              value={field.value ? field.value : null}
              onChange={field.onChange}
              onRemove={() => field.onChange(null)}
            />
          )}
        />
      </Stack>
    </Box>
  );
};
